<template>
  <email-box :hide-footer="email.is_scheduled">
    <button-link
      v-if="isMobile"
      class="mb-100"
      @click="goBackToList"
    >Back To List</button-link>

    <email-preview :email="computedEmail"></email-preview>

    <template v-slot:footer>
      <button-outlined
        class="ml-auto"
        @click="forward"
      >Forward
      </button-outlined>

      <button-outlined
        class="ml-100"
        @click="replyAll"
      >Reply All
      </button-outlined>

      <button-default
        class="ml-100"
        @click="reply"
      >Reply
      </button-default>
    </template>
  </email-box>
</template>

<script>
import EmailBox from "./EmailBox"
import EmailPreview from "./EmailPreview"
import dates from "../../../services/dates";

export default {
  name: "CurrentEmail",
  components: {EmailPreview, EmailBox},
  props: {
    email: {
      type: Object,
      required: true
    },
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
    computedEmail() {
      return this.email
    },
    date() {
      return dates.formatAsDate(this.email.created_at)
    }
  },
  methods: {
    goBackToList() {
      this.$emit('back')
    },
    reply() {
      this.$emit('reply', this.email)
    },
    replyAll() {
      this.$emit('replyAll', this.email)
    },
    forward() {
      this.$emit('forward', this.email)
    }
  },
}
</script>
